import {
  configureStore,
  createSlice,
  createListenerMiddleware,
  type PayloadAction
} from "@reduxjs/toolkit";
import { readSessionValue, writeSessionValue } from "../lib/session-draft";

interface SessionState {
  sessionId: string | null;
}
const initialState: SessionState = { sessionId: readSessionValue("eafSessionId") };
const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionId(state, action: PayloadAction<string | null>) {
      state.sessionId = action.payload;
    }
  }
});

export const { setSessionId } = sessionSlice.actions;
const persistence = createListenerMiddleware();
persistence.startListening({
  actionCreator: setSessionId,
  effect: (action) => {
    writeSessionValue("eafSessionId", action.payload);
  }
});
export const store = configureStore({
  reducer: { session: sessionSlice.reducer },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(persistence.middleware)
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
